import { makeStyles, Theme } from '@material-ui/core';
import FacebookPNG from 'assets/images/facebook.png';
import React, { ReactElement } from 'react';

const useStyles = makeStyles((theme: Theme): any => ({
  logo: {
    width: '24px',
    height: '24px',
    objectFit: 'cover',
  },
}));

function Facebook(): ReactElement {
  const classes: any = useStyles();
  return <img src={FacebookPNG} alt="Facebook logo" className={classes.logo} />;
}

export default Facebook;
